@use '../@shared/mixins' as *;
@use '../../styles/global' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	.kol-nav {
		$root: &;

		display: grid;
		place-items: center;

		&__navigation {
			#{$root}:not(#{$root}--is-compact) & {
				width: 100%;
			}

			.kol-span {
				width: 100%;
				justify-content: flex-start;

				&__container {
					width: 100%;

					.kol-span__label {
						flex: 1;
					}
				}
			}
		}

		&__list {
			display: flex;
			margin: 0;
			padding: 0;
			flex-direction: column;
			list-style: none;
		}

		&__entry-wrapper {
			display: flex;
		}

		&__entry {
			flex-grow: 1;
		}
	}

	.kol-button {
		text-align: left;
	}
}
